(function (ws) {
    'use strict';

    ws.views.merakiValidationModal = ws.views.modal.extend({
        events: {
            'click .merakiSubmit': 'merakiSubmit',
            'click .merakiCancel': 'cancelModal'
        },

        /**
         * Initialize
         */
        initialize: function() {
            ws.views.modal.prototype.initialize.call(this);
        },

        merakiSubmit: function(e) {
            if (isQuotingSite) {
                this.eventAgg.trigger('merakiValidation' + 'close');
                this.eventAgg.trigger('checkSAPTimer', e);
            } else if (isOrderEntrySite) {
                this.eventAgg.trigger('submitFormByContactCompletenessCheck', true);
                this.eventAgg.trigger('merakiValidation' + 'close');
            }
        },

        cancelModal: function(e) {
            this.eventAgg.trigger('merakiValidation' + 'close');
        }

    });
}(westcon));
